import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {
  ButtonIcon, ButtonLabel, RoundedButton,
} from '../input/RoundedButton';
import { ENABLED_FEATURES, BRAND_COLOR } from '../../appenv';
import BookmarkedIcon from '../icons/Bookmarked';
import BookmarkIcon from '../icons/Bookmark';

const ItemContainer = styled.div`
  margin: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:first-of-type {
    margin-top: 0;
  }
`;

const LabelContainer = styled.div`
  font-size: 16px;
  line-height: 16px;
`;

const AttachmentViewButton = styled(RoundedButton)`
  background: ${BRAND_COLOR || '#8B383A'};
  width: 96px;
`;

const ActionsContainer = styled.div`
  display: flex;

  & > * {
    margin-left: 8px;
  }
`;

const AttachmentRow = ({ attachment, children }) => {
  if (!attachment.file) return null;
  return (
    <ItemContainer>
      {/* eslint-disable-next-line camelcase */}
      <LabelContainer>{attachment.file?.filename_download}</LabelContainer>
      <ActionsContainer>
        {children}
      </ActionsContainer>
    </ItemContainer>
  );
};

AttachmentRow.propTypes = {
  attachment: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
};

const BoothPitchAttachmentBookmarkButton = styled(RoundedButton)`
  width: 136px;
  border: 2px solid #DBDEE2;
  background: #FFFFFF;
  color: #484848;
`;

const AttachmentBookmarkIcon = ({ isBookmarked }) => (
  <ButtonIcon>
    {isBookmarked ? <BookmarkedIcon /> : <BookmarkIcon />}
  </ButtonIcon>
);

AttachmentBookmarkIcon.propTypes = {
  isBookmarked: PropTypes.bool.isRequired,
};

export const BoothPitchAttachmentRow = ({ attachment, isBookmarked, onBookmarkToggle }) => (
  <AttachmentRow attachment={attachment}>
    {
      ENABLED_FEATURES.bookmarks && (
        <BoothPitchAttachmentBookmarkButton onClick={onBookmarkToggle}>
          <AttachmentBookmarkIcon isBookmarked={isBookmarked} />
          <ButtonLabel>
            {isBookmarked ? 'Bookmarked' : 'Bookmark'}
          </ButtonLabel>
        </BoothPitchAttachmentBookmarkButton>
      )
    }
    <AttachmentViewButton onClick={() => window.open(attachment.file.data.full_url)}>View</AttachmentViewButton>
  </AttachmentRow>
);

BoothPitchAttachmentRow.propTypes = {
  onBookmarkToggle: PropTypes.func.isRequired,
  attachment: PropTypes.shape().isRequired,
  isBookmarked: PropTypes.bool.isRequired,
};

const RemoveButton = styled(RoundedButton)`
  background: #FFFFFF;
  border: 2px solid #DBDEE2;
  border-radius: 2px;
  color: #000000;
  width: 96px;
`;

export const BookmarksAttachmentRow = ({ attachment, onRemove }) => (
  <AttachmentRow attachment={attachment}>
    {attachment.removable && <RemoveButton onClick={onRemove}>Remove</RemoveButton>}
    <AttachmentViewButton onClick={() => window.open(attachment.file.data.full_url)}>View</AttachmentViewButton>
  </AttachmentRow>
);

BookmarksAttachmentRow.propTypes = {
  attachment: PropTypes.shape().isRequired,
  onRemove: PropTypes.func.isRequired,
};
